import { Link } from "react-router-dom";
import { Disc3, CircleDot, Wrench, Zap, Power, Gauge, ArrowRight } from "lucide-react";
import { SectionHeading, Reveal } from "./Reveal";
import { SERVICE_NAV } from "../data/services";

const ICONS = {
  brakes: Disc3,
  "wheel-bearing": CircleDot,
  suspension: Wrench,
  alternator: Zap,
  starter: Power,
  "tune-up": Gauge,
};

export function ServicesStrip({ heading = true }) {
  return (
    <section data-testid="services-strip" className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20">
      {heading && (
        <SectionHeading
          eyebrow="Our Services"
          title="Brakes First. Full Mobile Repair Too."
          sub="Every service below is performed at your home or workplace — no drop-offs, no waiting rooms."
        />
      )}
      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICE_NAV.map((s, i) => {
          const Icon = ICONS[s.value];
          return (
            <Reveal key={s.slug} delay={(i % 3) * 0.08}>
              <Link
                to={s.slug}
                data-testid={`service-strip-${s.value}`}
                className={`group flex h-full items-center justify-between border p-6 transition-all duration-300 hover:-translate-y-1 ${
                  s.featured
                    ? "border-crimson bg-crimson text-white hover:bg-crimsondark"
                    : "border-edge bg-slate2 hover:border-crimson/60"
                }`}
              >
                <span className="flex items-center gap-4">
                  <Icon className={`h-8 w-8 ${s.featured ? "text-white" : "text-crimson"}`} />
                  <span>
                    <span className={`block font-display text-2xl font-bold uppercase tracking-tight ${s.featured ? "text-white" : "text-slate-50"}`}>
                      {s.label}
                    </span>
                    {s.featured && (
                      <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-white/80">
                        Our specialty
                      </span>
                    )}
                  </span>
                </span>
                <ArrowRight className={`h-5 w-5 transition-transform group-hover:translate-x-1 ${s.featured ? "text-white" : "text-slate-400 group-hover:text-crimson"}`} />
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
